module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAUAQMAAACgZR+HAAAABlBMVEXMAAD////D80ESAAAAEElEQVQI12NksN8owEhbAgDmVxQVXzlhAAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/pe.png
// module id = 361
// module chunks = 0